import {
  SurveyAnswers,
  SurveyOption,
} from "@components/analytics/in-house/feedback/analytics-feedback-types";
import { blue } from "@flat-ui";

export const feedbackOptionRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  px: 1.5,
  py: 1.25,
  cursor: "pointer",
  borderRadius: "8px",
  border: "1px solid",
  userSelect: "none",
  transition: "border-color 0.15s, background-color 0.15s",
  "&:hover": { borderColor: blue[200] },
};

export const feedbackControlWrapperSx = {
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  "& .MuiFormControlLabel-root": { m: 0 },
  "& .MuiCheckbox-root, & .MuiRadio-root": { p: 0 },
};

/** Value of the option that reveals the required free-text field. */
export const OTHER_VALUE = "other";

/** Options for this multi-select decision options (Step1) */
export const DECISIONS_OPTIONS: SurveyOption[] = [
  {
    value: "audit",
    label: "Prove who accessed or changed what (audit / compliance)",
  },
  {
    value: "value",
    label: "Show the value of captured data — is it being viewed & used",
  },
  {
    value: "activity",
    label:
      "See how actively people are capturing — and spot training or quality gaps",
  },
  {
    value: "reporting",
    label: "Report usage to an end customer / contractor",
  },
  {
    value: OTHER_VALUE,
    label: "Something else…",
  },
];

/** Options for this single-select role options (Step3) */
export const ROLE_OPTIONS: SurveyOption[] = [
  { value: "pm", label: "Project / account manager" },
  { value: "bim", label: "BIM / VDC / digital construction lead" },
  { value: "it", label: "IT, security or compliance" },
  { value: "field", label: "Field / capture user or lead" },
  { value: "reseller", label: "Reseller / service provider" },
  { value: OTHER_VALUE, label: "Other" },
];

/** Formats the collected survey answers into the feedback message to submit. */
export function buildFeedbackMessage(answers: SurveyAnswers): string {
  const decisions = answers.decisions
    .map((decision) =>
      decision === OTHER_VALUE
        ? answers.decisionOther
        : (DECISIONS_OPTIONS.find((option) => option.value === decision)
            ?.label ?? "")
    )
    .filter((decision) => decision.trim().length > 0)
    .join("\n");

  const jobFunction =
    answers.jobFunction === OTHER_VALUE
      ? answers.jobFunctionOther
      : (ROLE_OPTIONS.find((option) => option.value === answers.jobFunction)
          ?.label ?? "");

  return [
    `\n**Q1: When you open analytics, what are you usually trying to decide?**\n${decisions}`,
    `**Q2: If we could make one improvement first, what would help you most?**\n${answers.oneThing}`,
    `**Q3: What best describes your role?**\n${jobFunction}`,
  ].join("\n\n");
}
